import * as Yup from 'yup';

export const SwitchHospitalSchema = Yup.object().shape({
  hospitalId: Yup.number().required('Hastane seçimi zorunludur'),
  tagId: Yup.number().required('Etiket seçimi zorunludur'),
});
